import isNullish from './isNullish'

const registerGlobals = (): void => {
  window.isNullish = isNullish
}

export default registerGlobals
